const toastSettings = {
  position: "top-right",
  reverseOrder: false,
  containerStyle: {
    top: "4rem",
  },
};
export { toastSettings };
